'use client'

import clsx from 'clsx'

import type { IconButtonProps } from './types'

export default function IconButton({
	icon: Icon,
	label,
	variant = 'square',
	active = false,
	disabled = false,
	className,
	...props
}: IconButtonProps) {
	return (
		<button
			type="button"
			aria-label={label}
			aria-pressed={variant === 'square' ? active : undefined}
			disabled={disabled}
			className={clsx(
				variant === 'square' ? 'icon-button-square' : 'icon-button',
				variant === 'square' && active && 'icon-button-square-active',
				className,
			)}
			{...props}
		>
			<Icon className={variant === 'square' ? 'size-6' : 'size-5'} aria-hidden="true" />
		</button>
	)
}
